import React from 'react';
import { ListItemIcon, ListItemText, Checkbox } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { green, grey } from '@mui/material/colors';

const IngredientItem = ({ ingredient, isAdmin, showName = true, showCheckbox = true }) => {
  return (
    <>
      {(ingredient.revisado) && (
        <ListItemIcon style={{ minWidth: '30px' }}>
          <CheckCircleIcon
            sx={{
              fontSize: '1.2rem',
              color: green[500],
            }}
          />
        </ListItemIcon>
      )}
      {showName && <ListItemText primary={ingredient.name} />}
    </>
  );
};

export default IngredientItem;